/**
 * Send text to the Netlify function that calls Claude to polish it.
 *
 * `kind` controls the prompt:
 *   - "chunk-title"  : section heading
 *   - "bit-title"    : short slide headline
 *   - "dictation"    : long-form dictated speaker notes
 *
 * Returns the polished string. Throws on network / server errors so
 * callers can show a useful message.
 */
export async function polishWithClaude(text, kind) {
  if (!text || !text.trim()) return '';

  const res = await fetch('/.netlify/functions/polish', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, kind }),
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(
      `Polish failed (${res.status}). ${
        detail || 'Make sure ANTHROPIC_API_KEY is set in the Netlify dashboard.'
      }`
    );
  }

  const data = await res.json();
  return (data?.polished ?? '').trim();
}
